import StorageService from "../services/storage.service";

export async function getUrlGrafana(varcontract, from, to, kiosk, signal) {
    try {
        const res = await request2('/grafana', 'POST', {varcontract, from, to, kiosk}, {}, signal)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        if (e?.name === 'AbortError') {
            throw e
        }
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getReferer(kodDog, signal) {
    try {
        const res = await request2('api/grafan/get-referer', 'POST', {kod_dog: kodDog}, {}, signal)
        /*res.data = {referer : 'https://lk.ies-garant.ru/grafana/d/bdzrgqtw42fpca/tarifnoe-menju?var-contract=7838&from=2025-06-30T21:00:00.000Z&to=2025-07-31T20:59:59.000Z&kiosk=&orgId=1&timezone=Europe%2FMoscow&var-contract_id=e2a5ee2e-2729-4b0c-aaf3-52e09673534e&var-wholesale_retail=e2a5ee2e-2729-4b0c-aaf3-52e09673534e&var-applied_category_price_id=1dcda411-8805-46ae-bc0d-eeefe23b5a16&var-service_points=1c8b1de7-03f2-4d13-b6e0-bdf7745cfd6c&var-category_price=1dcda411-8805-46ae-bc0d-eeefe23b5a16&var-category_price=5ce64b6e-1697-43bf-9832-24707310c0b2&var-category_price=295e9369-34c9-4515-84b6-60ea07620153&var-category_price_allows=$__all&var-max_power_interval=5162e068-1fe2-4f93-bb54-c33b142566a8&var-napr_level=763ee2be-44c4-4270-a05a-7ce22f5bf872'}
        res.found = true
        res.message = 'OK'*/
        return {
            isOk: true,
            data: res.data.referer
        }
    } catch (e) {
        if (e?.name === 'AbortError') {
            throw e
        }
        return {
            isOk: false,
            message: e.message
        }
    }
}

const request2 = async (url, method = 'GET', body = null, headers = {}, signal) => {
    try {
        if (body) {

            if (headers !== 'multipart') {
                headers['Content-Type'] = 'application/json'
                body = JSON.stringify(body)
            } else {
                headers = []
            }

        }

        var response = await fetch(url, {method, body, headers, signal})

        //если не авторизован, попробуем сделать refresh
        if (response.status === 401) {
            const auth = StorageService.getLocalAuth()
            console.log('update access key...')

            const body_auth = JSON.stringify({ fingerprint: auth && auth.fingerprint })
            const headers_auth = { 'Content-Type': 'application/json' }

            const res_auth = await fetch('/api/account/refresh', {
                method: 'POST',
                body: body_auth,
                headers: headers_auth
            })

            if (res_auth.status === 401) {
                StorageService.removeLocalAuth()
                window.location.href = '/';
                return
            }

            // еще раз выполнить запрос
            response = await fetch(url, {method, body, headers, signal})
        }
        const data = await response.json()
        console.log('(' + url + ') Server:', data)
        if (!response.ok) {
            if (data && data.status && data.status === 'reset') {
                //если пользователю сбросили пароль принудительно
            } else if (url.includes('login')) {
                return {isOk: false, message: data.message}
            } else if (data.message === 'Ошибка аутентификации. Перезагрузите страницу') {
                window.location.href = '/';
            } else throw new Error(data.message || 'Что-то пошло не так')
        }

        return data
    } catch (e) {
        if (url.includes('login')) return {isOk: false, message: 'Неизвестная ошибка! Возможно, сервер недоступен.'}
        throw e
    }
}
